export const ServiceFeatureFlagNamesEnums = Object.freeze({
    Workflow_AdviceAndGuidanceOverview: 'Workflow_AdviceAndGuidanceOverview',
    Documents_ConfirmCancelNonMandatoryFields:
        'Documents_ConfirmCancelNonMandatoryFields',
})
